import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'

const AlertMessage = observer(() => {
    const { popupStore } = useContext(StoresContext)
    const alertData = popupStore.alertData

    if (!alertData || !alertData.message) {
        return null
    }

    return (
        <div className={`alert-message-component ${alertData.isError ? 'error' : ''}`}>
            <p>{alertData.message}</p>
            {alertData.isError ? (
                <img src={ICONS.alertError} alt="error" />
            ) : (
                <img src={ICONS.alertAccess} alt="access" />
            )}
        </div>
    )
})

export default AlertMessage
